import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'emotion-theming';
import c from 'classnames';
import ContentLoader from '../ContentLoader';
import s from './styles';

@withTheme
class OverlayLoader extends React.Component {
  static propTypes = {
    active: PropTypes.bool.isRequired
  };

  render() {
    const { active, children, theme, className } = this.props;

    return (
      <div className={c(s.root(), className)}>
        {children}

        {active && (
          <div className={s.overlay(theme)}>
            <ContentLoader />
          </div>
        )}
      </div>
    );
  }
}

export default OverlayLoader;
